import styled from 'styled-components'

export const MarkAnchor = styled.span`
  position: absolute;
  top: 0;
  left: 30px;
  z-index: 1000;
`
export const MarkTrigger = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 14px;

  &.marked {
    background: #367f98;
  }
`

export const MarkContent = styled.div`
  width: 220px;

  .ant-input {
    margin-top: 8px;
  }
`

export const MarkActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`
